import React from 'react';
import AppPage from './AppPage';
import {
  getSignupErrorMessage,
  getSignupRequestId,
} from '../../api/signup';

function InvalidLink({ error }) {
  const message = error
    ? getSignupErrorMessage(error, 'We could not load your signup.')
    : 'This signup link looks incomplete. Please open the exact link from your email.';
  const requestId = error ? getSignupRequestId(error) : null;

  return (
    <AppPage>
      <h1 className="signup-title">We can&apos;t open this signup link</h1>
      <p className="signup-sub break-words">{message}</p>
      <p className="text-sm text-up-clr-dark-grey leading-relaxed">
        If the problem persists, reply to the email that brought you here and
        we&apos;ll sort it out.
      </p>
      {requestId && (
        <p className="text-xs text-up-clr-light-grey mt-4">
          Reference: {requestId}
        </p>
      )}
    </AppPage>
  );
}

export default InvalidLink;
